// src/auth/AuthProviderWithHistory.jsx
import { useEffect } from 'react';
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { authConfig } from './authConfig';
import { setupInterceptors } from '../api/axiosInstance';

// Small child component just to wire interceptors once Auth0 is usable
function InterceptorsInitializer() {
    const { isLoading, getAccessTokenSilently, isAuthenticated } = useAuth0();

    useEffect(() => {
        if (!isLoading) {
            // Wire them regardless; request interceptor will fetch token if auth’d
            setupInterceptors(getAccessTokenSilently);
        }
    }, [isLoading, isAuthenticated, getAccessTokenSilently]);

    return null;
}

const AuthProviderWithHistory = ({ children }) => {
    const navigate = useNavigate();

    const onRedirectCallback = (appState) => {
        navigate(appState?.returnTo || window.location.pathname);
    };

    return (
        <Auth0Provider
            domain={authConfig.domain}
            clientId={authConfig.clientId}
            authorizationParams={{
                redirect_uri: `${window.location.origin}/authcallback`,
                audience: authConfig.audience,
                scope: authConfig.scope,
            }}
            useRefreshTokens={true}
            cacheLocation="localstorage"
            onRedirectCallback={onRedirectCallback}
        >
            <InterceptorsInitializer />
            {children}
        </Auth0Provider>
    );
};

AuthProviderWithHistory.propTypes = { children: PropTypes.node.isRequired };
export default AuthProviderWithHistory;
